const CHANGE_FEEDBACK_FILE_LIST_CONDITIN = 'CHANGE_FEEDBACK_FILE_LIST_CONDITIN';
const CHANGE_FEEDBACK_FILE_LIST_PAGE = 'CHANGE_FEEDBACK_FILE_LIST_PAGE';
const CHANGE_FEEDBACK_FILE_FILE_LIST_LIST = 'CHANGE_FEEDBACK_FILE_FILE_LIST_LIST';
const CHANGE_NEW_FEEDBACK_FILE_LIST_CONDITION = 'CHANGE_NEW_FEEDBACK_FILE_LIST_CONDITION';

const FeedBackFileListModel = function (){
    const name = 'feedback_file_list';
    return {
        name,
        state:{
            condition:{
                mchNo:'',
            },
            newModal:{
                fileId:'',
                remark:'',
                path:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            },
            // personList:[]
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
                // getPersonList:()=>currentState.personList,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_FILE_LIST_CONDITIN,
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_NEW_FEEDBACK_FILE_LIST_CONDITION,
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_FILE_FILE_LIST_LIST,
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_FILE_LIST_PAGE,
                    page
                })
            },
            // changePersonList:(list) => (dispatch,getState) => {
            //     dispatch({
            //         type:'CHANGE_SERVICE_FOLLOW_UP_PERSON_SKU_LIST',
            //         list
            //     })
            // }
        },
        reducers:{
            condition:(state = FeedBackFileListModel.state.condition, action) => {
                if(action.type === CHANGE_FEEDBACK_FILE_LIST_CONDITIN){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = FeedBackFileListModel.state.newModal, action) => {
                if(action.type === CHANGE_NEW_FEEDBACK_FILE_LIST_CONDITION){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = FeedBackFileListModel.state.page, action) => {
                if(action.type === CHANGE_FEEDBACK_FILE_LIST_PAGE){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = FeedBackFileListModel.state.list , action ) => {
                if(action.type === CHANGE_FEEDBACK_FILE_FILE_LIST_LIST){
                    return [ ...action.list ];
                };
                return state;
            },
            // personList:(state = ServiceFollowUpModel.state.personList , action ) => {
            //     if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_PERSON_LIST'){
            //         return [ ...action.list ];
            //     };
            //     return state;
            // }
        }
    }
}();

export default FeedBackFileListModel;


// WEBPACK FOOTER //
// ./src/models/FeedBackFileListModel.js